
import { defineComponent, provide, ref } from "vue";
import CorporateHeader from "@/components/UserAccounts/CorporateHeader.vue";
import UserNewArticles from "~/components/UserAccounts/UserNewArticles.vue";
import UserRecruits from "~/components/UserAccounts/UserRecruits.vue";
import UserColumns from "~/components/UserAccounts/UserColumns.vue";
import UserInfo from "~/components/UserAccounts/UserInfo.vue";
import UserCorporateLayout from "~/components/UserAccounts/UserCorporateLayout.vue";
import UserImageGallery from "~/components/UserAccounts/UserImageGallery.vue";

export default defineComponent({
  name: "UserCorporatePage",
  components: {
    UserCorporateLayout,
    UserInfo,
    UserColumns,
    UserRecruits,
    UserNewArticles,
    CorporateHeader,
    UserImageGallery
  },
  props: {
    userId: {
      type: Number,
      required: true
    },
    mediumId: {
      type: Number,
      default: 0
    },
    userIdHash: {
      type: String,
      required: true
    },
    facebookAppKey: {
      type: Number,
      required: true
    },
    facebookId: {
      type: String,
      default: ""
    },
    isCurrentUserPage: {
      type: Boolean,
      default: false
    },
    reader: {
      type: Boolean,
      require: false,
      default: false
    },
    favedArticleIds: {
      type: Array,
      require: false,
      default: () => []
    }
  },
  setup(props) {
    // バケツリレーが深くなる値はprovideに保存しておく
    provide("facebookAppKey", props.facebookAppKey);
    provide("facebookId", props.facebookId);
    const loading = ref(true);
    return {
      loading,
    };
  }
});
